{
	"id": "main-stream",
	"hlsPlaybackUrl": "https://vb-lxp-media.vbricklab.com/live-streaming/84fb3512-baee-4763-bcfe-ecbffa325c32/video-999/video-999.m3u8",
	"hlsPromotionalVideoUrl": "https://vb-lxp-media-qa.vbricklab.com/videos/race-small-promo-video/94fb9197-92a0-470a-b844-8156074b833d.m3u8",
	"isLive": true
}
